import Login from "../components/Authentication/Login";

const LoginPage = (): JSX.Element => {
  return <Login />;
};

export default LoginPage;
